<template>
<div class="chapter">
<div class="inner_page">
<section id="fm1" title="Foreword">
<p class="fm_headab"><span class="right_1" epub:type="pagebreak" id="page_xiii" title="xiii"><a href="#/text/9780063075771_Contents#rfm1">Foreword</a></span></p>
<div class="fig_10"><img alt="image" src="images/common.jpg"/></div>
<p class="non_para"><i>For their helpful advice and criticism I want to thank Helen Thurber,</i> Gus Lobrano, Kenneth MacLean and John McGiffert. I am indebted to Harcourt Brace for their permission to include six stories from “<span href="#/text/9780063075771_Part_2#pt2" title="Link target outside of Sample">My World and Welcome to It</span>,” and “<span href="#/text/9780063075771_Chapter_65#ch114" title="Link target outside of Sample">The War Between Men and Women</span>” and a number of other drawings from “<span href="#/text/9780063075771_Part_9#pt9" title="Link target outside of Sample">Men, Women and Dogs</span>.” “<span href="#/text/9780063075771_Chapter_6#ch6" title="Link target outside of Sample">Recollections of the Gas Buggy</span>” is reprinted through the courtesy of <i>The Saturday Review of Literature.</i> The other pieces of the drawings originally appeared in <i>The New Yorker.</i></p>
<p class="in_para">Most of the books represented here were published under the supervision of the late Gene Saxton, and this anthology was his idea. I salute the memory of a good friend and a wise and kindly counsellor.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780063075771_Foreword.vue?2cac3c23